const doc = [({"en":({"js":({"admin":({"contacts":({"link":({"no_contact":"No contact"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;